import React from 'react';
import { Typography, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Information from './Information/Information';
import HelpfulTips from './HelpfulTips/HelpfulTips';
import ReportsList from './ReportsList/ReportsList';
import {
  contentActions,
  selectIsCalculatorDashboardLoading,
  selectCalculatorDashboardContent,
} from '../../../redux/contentSlice';
import useOnMount from '../../../hooks/useOnMount';
import { Spinner } from '../../../components';
import useStyles from './CalculatorDashboard.styles';
import Grid from '@mui/material/Grid';

const CalculatorDashboard = () => {
  const classes = useStyles();
  const testid = 'cd';
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsCalculatorDashboardLoading);
  const content = useSelector(selectCalculatorDashboardContent);

  useOnMount(() => {
    if (!content) dispatch(contentActions.fetchCalculatorDashboardContent());
  });

  return (
    <Grid container spacing={4}>
      {isLoading ? (
        <Grid size={12}>
          <Box className={classes.informationSpinnerContainer}>
            <Spinner show={isLoading} inline />
          </Box>
        </Grid>
      ) : (
        <>
          <Grid size={{ xs: 12}}>
            <Typography
              variant="h1"
              className={ classes.title }
              data-testid={`${testid}__title`}
              dangerouslySetInnerHTML={{ __html: content?.title || '' }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 8 }}>
            <Information
              title={content?.main.title}
              description={content?.main.text}
              testid={testid}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <HelpfulTips
              title={content?.tips.title}
              tips={content?.tips.items}
              testid={testid}
            />
          </Grid>
        </>
      )}

      <Grid size={{ xs: 12}}>
        <ReportsList />
      </Grid>
    </Grid>
  );
};

export default CalculatorDashboard;
